import type { HttpPort } from "~/lib/http";

export interface TeacherClass {
  id: string;
  name: string;
  description: string | null;
  join_code: string;
  teacher_id: string;
  teacher_user_id?: string | null;
  teacher_name?: string | null;
  school_year: string | null;
  school_name: string | null;
  school_id?: string | null;
  teacher_school_name?: string | null;
  is_active: boolean;
  checkin_saturday: boolean;
  checkin_sunday: boolean;
  student_count: string | number;
  // "edit": diese Lehrkraft bearbeitet die Klasse; "read": sie liest nur mit (M46).
  access_level?: "edit" | "read";
}

export interface ClassDraft {
  name: string;
  description?: string;
  schoolYear?: string;
}

export function createClassesModule(http: HttpPort, token: string) {
  return {
    async list(): Promise<TeacherClass[]> {
      const result = await http.request<{ classes?: TeacherClass[] }>({ path: "/classes", token });
      return result.classes ?? [];
    },
    async create(draft: ClassDraft): Promise<TeacherClass> {
      const result = await http.request<{ class: TeacherClass }>({
        path: "/classes",
        method: "POST",
        token,
        body: draft
      });
      return result.class;
    },
    async update(classId: string, draft: ClassDraft): Promise<TeacherClass> {
      const result = await http.request<{ class: TeacherClass }>({
        path: `/classes/${classId}`,
        method: "PUT",
        token,
        body: draft
      });
      return result.class;
    },
    async remove(classId: string): Promise<void> {
      await http.request({ path: `/classes/${classId}`, method: "DELETE", token });
    },
    async setWeekend(classId: string, input: { saturday?: boolean; sunday?: boolean }): Promise<void> {
      await http.request({ path: `/classes/${classId}/weekend-checkin`, method: "PATCH", token, body: input });
    },
    async changeJoinCode(classId: string, joinCode?: string): Promise<string> {
      const result = await http.request<{ joinCode: string }>({
        path: `/classes/${classId}/join-code`,
        method: "PATCH",
        token,
        body: joinCode ? { joinCode } : {}
      });
      return result.joinCode;
    }
  };
}

export type ClassesModule = ReturnType<typeof createClassesModule>;
